module.exports = {
  email: 'jamesaoki7@gmail.com',

  socialMedia: [
    {
      name: 'Codepen',
      url: 'mailto:jamesaoki7@gmail.com',
    },
    {
      name: 'Instagram',
      url: 'https://discord.com/users/941586639602479174',
    },
    {
      name: 'PlayStore',
      url: 'https://t.me/DripMicro',
    },
    {
      name: 'Twitter',
      url: 'https://join.skype.com/invite/EFeSGDmc1Sin',
    },
    {
      name: 'GitHub',
      url: 'https://github.com/DripMicro',
    },
    // {
    //   name: 'Instagram',
    //   url: 'https://www.instagram.com/bchiang71a1a1f',
    // },
    // {
    //   name: 'Twitter',
    //   url: 'https://twitter.com/bchiang7',
    // },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/',
    },
    // {
    //   name: 'Codepen',
    //   url: 'https://codepen.io/bchiang7',
    // },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Work',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#cfcfcf',
    navy: '#1e1e1e',
    darkNavy: '#232323',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
